import { useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { PanelMenu } from "primereact/panelmenu"
import useMainMenu from "../../hooks/useMainMenu"
import {
  buildPanelMenuModel,
  renderMaterialIconMenuItemTemplate,
} from "./components/helpers/menuBuilder"

import baseStyles from "../../styles/SidebarPanelMenuBase.module.css"

export default function ApplicationMenuSidebar() {
  const navigate = useNavigate()
  const location = useLocation()

  // Pull only the Application Management section from the shared menu config.
  const { menuItems: applicationSections, resolveMenuPath } = useMainMenu({
    includeLabels: ["Application Management"],
  })

  // includeLabels returns at most one top-level match; render only its children
  // so this sidebar stays a simple submenu rather than an extra accordion level.
  const applicationItems = useMemo(
    () =>
      Array.isArray(applicationSections?.[0]?.items)
        ? applicationSections[0].items
        : [],
    [applicationSections],
  )

  const applicationMenuModel = useMemo(
    () =>
      // Keep route activation, icon rendering, and placeholder path resolution
      // aligned with other sidebars by using the shared menu builder.
      buildPanelMenuModel({
        items: applicationItems,
        pathname: location.pathname,
        navigate,
        itemTemplate: renderMaterialIconMenuItemTemplate,
        activeClassName: baseStyles.menuLinkActiveItem,
        resolvePath: resolveMenuPath,
        // Skip malformed entries from config snapshots.
        includeItem: ({ item }) => Boolean(item?.label),
      }),
    [applicationItems, location.pathname, navigate, resolveMenuPath],
  )

  if (!applicationMenuModel.length) {
    return null
  }

  return (
    <div className={baseStyles.menuRoot}>
      <PanelMenu
        key={`application-menu-${location.pathname}`}
        model={applicationMenuModel}
        multiple={false}
      />
    </div>
  )
}
